import React, { useEffect, useState } from "react";
import { $transactions, getTransactionsByYYYYMM } from "../../payments/logics/getTransactions";
import { useStore } from "effector-react";
import { AccountTransactionsItem } from "../atoms/AccountTransactionsItem";
import { Button } from "react-bootstrap";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent";

interface IAccountTransactions {
  accountId: number;
}

const incrementCount = 3

//отрисовывает последнее начисление по текущему аккаунту
export const AccountTransactions = ({accountId}: IAccountTransactions) => {
  const transactions = useStore($transactions); 
  const [hideAll, setHideAll] = useState(true);
  const [showCount, setShowCount] = useState(3)

  function showMorelCards() {
    let tranLen = transactions.transactionsByMonth.length
    setShowCount(showCount + incrementCount > tranLen ? tranLen : showCount + incrementCount)
  }
  useEffect(()=>{
    console.log(transactions)
  },[hideAll])
  return (
    <>
      <div>
        <Button style={{textDecorationLine: "underline", marginTop: "10px", paddingLeft: "0", boxShadow: "none"}} onClick={() => setHideAll(!hideAll)} variant="default" >{hideAll ? "Показать историю операций" : "Скрыть историю операций" }</Button>
        {/* {getCustomUserAgent()===getCustomUserAgentASB()?<p>Не работает, операций еще ни у кого нет <i className="fal fa-hand-point-up"></i></p>:<></>} */}
      </div>
      <div style={{display: hideAll ? "none" : "block"}}>
        <ul className="charges__list">
          {transactions.transactionsByMonth.slice(0, showCount).map((e, i) => (
            <AccountTransactionsItem i={i} key={i} transactionByMonth={e} accountId={accountId} monthTransactions={getTransactionsByYYYYMM(e.yyyymm)} hideInfo={i != 0} />
          ))}
        </ul>
        <button hidden={showCount >= transactions.transactionsByMonth.length} type="button" onClick={showMorelCards} className="charges__button-more">
          Загрузить ещё...
        </button>
      </div>
    </>
  );
};
